/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class s{constructor(s,i,t,h){this.total=s,this.visible=i,this.missing=t,this.pending=h}}export{s as GraphicsCorePerformanceInfo};
